import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    parse(value: any): Date | null {
        if(typeof value !== 'string' || !value.trim()) {
            return super.parse(value);
        }
        const parts = value.trim().split(/[/.\-]/);
        if(parts.length !== 3 || parts.some(part => isNaN(Number(part)))){
            return new Date(NaN);
        }

        const fieldOrder = this._getFieldOrder();
        const fields: { day?: number; month?: number; year?: number } = {};
        fieldOrder.forEach((field, i) => (fields[field] = Number(parts[i])));

        if(fields.day === undefined || fields.month === undefined ||fields.year == undefined) return new Date(NaN);

        const date = new Date();
        date.setFullYear(fields.year, fields.month - 1, fields.day);
        date.setHours(0,0,0,0);

        const matchesInput = 
            date.getFullYear() === fields.year && date.getMonth() == fields.month -1 && date.getDate() === fields.day;
        
            return matchesInput ? date : new Date(NaN);
    }

    /** Returns ['day', 'month', 'year'] in whichever order the current locale displays them. */
    private _getFieldOrder(): Array<'day' | 'month' | 'year'> {
        return new Intl.DateTimeFormat(this.locale)
            .formatToParts(new Date(2030,0,2))
            .filter((part): part is Intl.DateTimeFormatPart & { type: 'day' | 'month' | 'year' } =>
                part.type === 'day' ||part.type === 'month' || part.type === 'year')
            .map(part => part.type);
    }
}